import React from "react";
import PropTypes from "prop-types";

// Displays call detail count data
function CallDetailsCount({ callData }) {
  return (
    <div className="call-details-count">
      Total Calls Listed: <span>{callData ? (Common.formatNumberWithCommas(callData[0].total_calls)) : "0"}</span>
      Unique Callers: <span>{callData ? (Common.formatNumberWithCommas(callData[0].unique_callers)) : "0"}</span>
      Repeat Callers: <span>{callData ? (Common.formatNumberWithCommas(callData[0].repeat_caller)) : "0"}</span>
    </div>
  );
}

CallDetailsCount.propTypes = {
  callData: PropTypes.array,
};

export default CallDetailsCount;
